export default __webpack_public_path__ + "static/media/9_María Rosal_179x177.185a229e.webp";